export default "__VITE_ASSET__C_vNbi1T__"